export default __webpack_public_path__ + "static/media/after@2x.86e4905f.png";